import React from 'react';
import { useSelector } from 'react-redux';

import InsuranceColumn from '../../columns/insurance-column';
import Global from '../../../store/global-selectors';
import { messages } from './messages';

const InsuranceColumnComponent = ({ fulfillmentId }) => {
  const ret = useSelector((state) => Global.selectEntitiesReturnById(state, { fulfillmentId }));
  if (!ret) {
    return '';
  }

  return <InsuranceColumn data={ret} />;
};

export const Insurance = {
  getMessageDescriptor: () => messages.insurance,
  id: 'insurance',

  render: ({ fulfillmentId }) => {
    return <InsuranceColumnComponent fulfillmentId={fulfillmentId} />;
  },
};
